import { camelCase, get } from 'lodash';

const formatSearchResults = (items, columns) =>
  items.map((item) => {
    const formattedItem = {};
    columns.forEach((columnDef) => {
      const { funnelbackField, columnKey } = columnDef;
      formattedItem[columnKey] = get(item, funnelbackField);
    });

    const status = item.metaData?.status || '';
    if ('status' in formattedItem) {
      formattedItem.status = formattedItem?.status ? camelCase(formattedItem.status) : camelCase(status);
    }

    return formattedItem;
  });

export default formatSearchResults;
